import React from "react";
import * as Icon from "react-feather";
import { getUser } from "../utility/Common";

/*let _adminNavigation = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "collapse",
    icon: <Icon.Home size={20} />,
    children: [
      {
        id: "home",
        title: "Homes",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/home",
      },
      {
        id: "faculity",
        title: "FaculityMenue",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/home/faculity",
      },
      {
        id: "user_view",
        title: "View My Profile",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/app/user/user-view",
      },
      {
        id: "supervisor",
        title: "supervision.goto.link",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/home/information",
      },
    ],
  },
  {
    type: "groupHeader",
    groupTitle: "feature_1",
  },
  {
    id: "users",
    title: "User",
    type: "collapse",
    icon: <Icon.User size={20} />,
    children: [
      {
        id: "list",
        title: "List",
        type: "item",
        icon: <Icon.Users size={14} />,
        navLink: "/app/user/list",
      },
      {
        id: "add",
        title: "Add New Employee",
        type: "item",
        icon: <Icon.UserPlus size={14} />,
        navLink: "/app/user/add",
      },
    ],
  },
  {
    id: "websetting",
    title: "Website Setting",
    type: "collapse",
    icon: <Icon.Settings size={20} />,
    children: [
      {
        id: "blog",
        title: "Blog",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/blog",
      },
      {
        id: "gallery",
        title: "Image Gallery",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/gallery",
      },
      {
        id: "news",
        title: "News",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/news",
      },
      {
        id: "webpage",
        title: "Web Pages",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/webpage",
      },
      {
        id: "header",
        title: "Header",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/config/header",
      },
      {
        id: "footer",
        title: "Footer",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/config/footer",
      },
    ],
  },
  {
    id: "university",
    title: "University",
    type: "collapse",
    icon: <Icon.Award size={20} />,
    children: [
      {
        id: "studyYear",
        title: "Study Year",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/university/study-year",
      },
      {
        id: "department",
        title: "Department",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/university/department",
      },
      {
        id: "student",
        title: "Students",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/university/student",
      },
      {
        id: "subject",
        title: "Subjects",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/university/subject",
      },
    ],
  },
  {
    id: "Admission",
    title: "Admission",
    type: "collapse",
    icon: <Icon.Archive size={14} />,
    children: [
      {
        id: "info",
        title: "Info",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/admission",
      },
      {
        id: "applicant_list",
        title: "Applicant List",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/admission/entry",
      },
      {
        id: "questionnaire_entry_list",
        title: "Questionnaire Entry",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/questionnaire/entry",
      },
      {
        id: "questionnaire",
        title: "Manage Questionnaire",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/admission/questionnaire",
      },
    ],
  },
  {
    id: "onlineStudies",
    title: "Online Studies",
    icon: <Icon.Calendar size={20} />,
    type: "collapse",
    children: [
      {
        id: "department",
        title: "Department",
        type: "item",
        icon: <Icon.Circle size={14} />,
        navLink: "/panel/app/online/department/list",
      },
      {
        id: "subject",
        title: "Online_Subject",
        type: "item",
        icon: <Icon.Circle size={14} />,
        navLink: "/panel/app/online/subject/list",
      },
      {
        id: "student",
        title: "Online_Students",
        type: "item",
        icon: <Icon.Circle size={14} />,
        navLink: "/panel/app/online/student/list",
      },
      {
        id: "exam",
        title: "Online_Exams",
        type: "item",
        icon: <Icon.Circle size={14} />,
        navLink: "/panel/app/online/exam/list",
      },
    ],
  },
  {
    type: "groupHeader",
    groupTitle: "feature_2",
  },
  {
    id: "task",
    title: "Task",
    type: "collapse",
    icon: <Icon.Grid size={20} />,
    children: [
      {
        id: "listTask",
        title: "Task List",
        type: "item",
        icon: <Icon.List size={15} />,
        navLink: "/app/task/list",
      },
      {
        id: "todo",
        title: "Todo",
        type: "item",
        icon: <Icon.Zap size={20} />,
        navLink: "/todo/:filter",
        filterBase: "/todo/all",
      },
    ],
  },
  {
    id: "finance",
    title: "Finance",
    type: "collapse",
    icon: <Icon.BookOpen size={16} />,
    children: [
      {
        id: "bookkeeping",
        title: "Bookkeeping",
        type: "item",
        icon: <Icon.Inbox size={15} />,
        navLink: "/bookkeeping",
      },
      {
        id: "money_request",
        title: "Money Request",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/money-request",
      },
      {
        id: "finance_report",
        title: "Finance Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/finance-report",
      },
    ],
  },
  {
    id: "report",
    title: "Report",
    type: "collapse",
    icon: <Icon.Tablet size={16} />,
    children: [
      {
        id: "money_report",
        title: "Money Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/money-report",
      },
      {
        id: "task_report",
        title: "Task Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/task-report",
      },
      {
        id: "employee_report",
        title: "Employee Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/employee-report",
      },
      {
        id: "manual_report",
        title: "Manual Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/manual-report",
      },
    ],
  },
  {
    id: "template",
    title: "Template",
    type: "item",
    icon: <Icon.FileText size={20} />,
    navLink: "/app/template",
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <Icon.Mail size={20} />,
    navLink: "/email/:filter",
    filterBase: "/email/inbox",
  },
  {
    id: "chat",
    title: "Chat",
    type: "item",
    icon: <Icon.MessageSquare size={20} />,
    navLink: "/chat",
  },
  {
    id: "fileManager",
    title: "File Manager",
    type: "item",
    icon: <Icon.Save size={20} />,
    navLink: "/file-manager",
    collapsed: true,
  },
  {
    id: "calendar",
    title: "Calendar",
    type: "item",
    icon: <Icon.Calendar size={20} />,
    navLink: "/calendar",
  },
  {
    type: "groupHeader",
    groupTitle: "SUPPORT",
  },
  {
    id: "documentation",
    title: "Information about the system",
    icon: <Icon.Info size={20} />,
    type: "item",
    navLink: "/sysinfo",
  },
];*/

let adminNavigation = [
  {
    id: "home",
    title: "Homes",
    type: "item",
    icon: <Icon.Home size={20} />,
    navLink: "/home",
  },
  {
    id: "user_view",
    title: "View My Profile",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/app/user/user-view",
  },
  {
    id: "supervisor",
    title: "supervision.goto.link",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/home/information",
  },
  {
    id: "academic_system",
    title: "nav.academic_system",
    type: "collapse",
    icon: <Icon.Award size={20} />,
    children: [
      {
        id: "academic_affairs",
        title: "nav.academic_affairs",
        type: "collapse",
        icon: <Icon.Circle size={13} />,
        children: [
          {
            id: "faculity",
            title: "FaculityMenue",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/home/faculity",
          },
          {
            id: "studyYear",
            title: "Study Year",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/study-year",
          },
          {
            id: "subjects",
            title: "Subjects",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/subject",
          },
          {
            id: "jadwal",
            title: "Jadwal",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/jadwal",
          },
          {
            id: "online_exams",
            title: "الإختبارات الإكترونية",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/lecturer/online-exams",
          },
        ],
      },
      {
        id: "registration_admission",
        title: "nav.registration_admission",
        type: "collapse",
        icon: <Icon.Circle size={13} />,
        children: [
          {
            id: "student",
            title: "Students",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/student",
          },
          {
            id: "student_housing",
            title: "nav.student_housing",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/student-housing",
          },
          {
            id: "info",
            title: "Info",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/websetting/admission",
          },
          {
            id: "applicant_list",
            title: "Applicant List",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/websetting/admission/entry",
          },
        ],
      },
      {
        id: "onlineStudies",
        title: "Online Studies",
        icon: <Icon.Calendar size={13} />,
        type: "collapse",
        children: [
          {
            id: "online_department",
            title: "nav.O_Department",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/app/online/department/list",
          },
          {
            id: "online_subject",
            title: "Online_Subject",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/app/online/subject/list",
          },
          {
            id: "online_student",
            title: "Online_Students",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/app/online/student/list",
          },
          {
            id: "online_exam",
            title: "Online_Exams",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/app/online/exam/list",
          },
          {
            id: "questionnaire_entry_list",
            title: "Questionnaire Entry",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/websetting/questionnaire/entry",
          },
          {
            id: "questionnaire",
            title: "Manage Questionnaire",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/websetting/admission/questionnaire",
          },
        ],
      },
    ],
  },
  {
    id: "administrative_system",
    title: "nav.administrative_system",
    type: "collapse",
    icon: <Icon.Monitor size={20} />,
    children: [
      {
        id: "list",
        title: "List",
        type: "item",
        icon: <Icon.Users size={13} />,
        navLink: "/app/user/list",
      },
      {
        id: "listTask",
        title: "Task List",
        type: "item",
        icon: <Icon.List size={15} />,
        navLink: "/app/task/list",
      },
      {
        id: "todo",
        title: "Todo",
        type: "item",
        icon: <Icon.Zap size={20} />,
        navLink: "/todo/:filter",
        filterBase: "/todo/all",
      },
      {
        id: "websetting",
        title: "Website Setting",
        type: "collapse",
        icon: <Icon.Settings size={13} />,
        children: [
          {
            id: "frontinfo",
            title: "Frontinfo",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/websetting/frontinfo",
          },
          {
            id: "slider",
            title: "Slider Images",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/websetting/slider",
          },
          {
            id: "gallery",
            title: "Image Gallery",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/websetting/gallery",
          },
          {
            id: "blog",
            title: "Blog",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/websetting/blog",
          },
          {
            id: "news",
            title: "News",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/websetting/news",
          },
        ],
      },
      {
        id: "general admin",
        title: "nav.general_admin",
        type: "collapse",
        icon: <Icon.Circle size={13} />,
        children: [
          {
            id: "listTask",
            title: "Task List",
            type: "item",
            icon: <Icon.List size={15} />,
            navLink: "/app/task/list",
          },
          {
            id: "todo",
            title: "Todo",
            type: "item",
            icon: <Icon.Zap size={20} />,
            navLink: "/todo/:filter",
            filterBase: "/todo/all",
          },
          {
            id: "template",
            title: "Template",
            type: "item",
            icon: <Icon.FileText size={20} />,
            navLink: "/app/template",
          },
        ],
      },
    ],
  },
  {
    id: "finance",
    title: "Finance",
    type: "collapse",
    icon: <Icon.BookOpen size={16} />,
    children: [
      {
        id: "bookkeeping",
        title: "Bookkeeping",
        type: "item",
        icon: <Icon.Inbox size={15} />,
        navLink: "/bookkeeping",
      },
      {
        id: "money_request",
        title: "Money Request",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/money-request",
      },
      {
        id: "finance_report",
        title: "Finance Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/finance-report",
      },
    ],
  },
  {
    id: "feature 3",
    title: "feature_3",
    type: "collapse",
    icon: <Icon.Circle size={13} />,
    children: [
      {
        id: "chat",
        title: "Chat",
        type: "item",
        icon: <Icon.MessageSquare size={13} />,
        navLink: "/chat",
      },
      {
        id: "fileManager",
        title: "File Manager",
        type: "item",
        icon: <Icon.Save size={13} />,
        navLink: "/file-manager",
        collapsed: true,
      },
      {
        id: "email",
        title: "Email",
        type: "item",
        icon: <Icon.Mail size={13} />,
        navLink: "/email/:filter",
        filterBase: "/email/inbox",
      },
      {
        id: "calendar",
        title: "Calendar",
        type: "item",
        icon: <Icon.Calendar size={13} />,
        navLink: "/calendar",
      },
    ],
  },
  {
    id: "report",
    title: "Report",
    type: "collapse",
    icon: <Icon.Tablet size={13} />,
    children: [
      {
        id: "financial report",
        title: "nav.financial_report",
        type: "collapse",
        icon: <Icon.Tablet size={13} />,
        children: [
          {
            id: "money_report",
            title: "Money Report",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/money-report",
          },
          {
            id: "task_report",
            title: "Task Report",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/task-report",
          },
          {
            id: "employee_report",
            title: "Employee Report",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/employee-report",
          },
          {
            id: "manual_report",
            title: "Manual Report",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/manual-report",
          },
        ],
      },
      {
        id: "student_report",
        title: "Student Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/university/student-report",
      },
      {
        id: "template",
        title: "Template",
        type: "item",
        icon: <Icon.FileText size={20} />,
        navLink: "/app/template",
      },
    ],
  },
  {
    id: "documentation",
    title: "Information about the system",
    icon: <Icon.Info size={20} />,
    type: "item",
    navLink: "/sysinfo",
  },
];

let managerNavigation = [
  {
    id: "home",
    title: "Homes",
    type: "item",
    icon: <Icon.Home size={20} />,
    navLink: "/home",
  },
  {
    id: "user_view",
    title: "View My Profile",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/app/user/user-view",
  },
  {
    id: "supervisor",
    title: "supervision.goto.link",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/home/information",
  },
  {
    id: "academic_system",
    title: "nav.academic_system",
    type: "collapse",
    icon: <Icon.Award size={20} />,
    children: [
      {
        id: "academic_affairs",
        title: "nav.academic_affairs",
        type: "collapse",
        icon: <Icon.Circle size={13} />,
        children: [
          {
            id: "faculity",
            title: "FaculityMenue",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/home/faculity",
          },
          {
            id: "studyYear",
            title: "Study Year",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/study-year",
          },
          {
            id: "subjects",
            title: "Subjects",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/subject",
          },
          {
            id: "jadwal",
            title: "Jadwal",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/jadwal",
          },
          {
            id: "online_exams",
            title: "الإختبارات الإكترونية",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/lecturer/online-exams",
          },
        ],
      },
      {
        id: "registration_admission",
        title: "nav.registration_admission",
        type: "collapse",
        icon: <Icon.Circle size={13} />,
        children: [
          {
            id: "student",
            title: "Students",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/student",
          },
          {
            id: "info",
            title: "Info",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/websetting/admission",
          },
          {
            id: "applicant_list",
            title: "Applicant List",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/websetting/admission/entry",
          },
          // {
          //   id: "student_housing",
          //   title: "nav.student_housing",
          //   type: "item",
          //   icon: <Icon.Circle size={13} />,
          //   navLink: "/panel/university/student-housing",
          // },
        ],
      },
    ],
  },
  {
    id: "administrative_system",
    title: "nav.administrative_system",
    type: "collapse",
    icon: <Icon.Circle size={13} />,
    children: [
      {
        id: "general admin",
        title: "nav.general_admin",
        type: "collapse",
        icon: <Icon.Circle size={13} />,
        children: [
          {
            id: "listTask",
            title: "Task List",
            type: "item",
            icon: <Icon.List size={15} />,
            navLink: "/app/task/list",
          },
          {
            id: "todo",
            title: "Todo",
            type: "item",
            icon: <Icon.Zap size={20} />,
            navLink: "/todo/:filter",
            filterBase: "/todo/all",
          },
        ],
      },
    ],
  },
  {
    id: "finance",
    title: "Finance",
    type: "collapse",
    icon: <Icon.BookOpen size={16} />,
    children: [
      {
        id: "money_request",
        title: "Money Request",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/money-request",
      },
      {
        id: "finance_report",
        title: "Finance Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/finance-report",
      },
    ],
  },
  {
    id: "feature 3",
    title: "feature_3",
    type: "collapse",
    icon: <Icon.Circle size={13} />,
    children: [
      {
        id: "email",
        title: "Email",
        type: "item",
        icon: <Icon.Mail size={13} />,
        navLink: "/email/:filter",
        filterBase: "/email/inbox",
      },
      {
        id: "chat",
        title: "Chat",
        type: "item",
        icon: <Icon.MessageSquare size={13} />,
        navLink: "/chat",
      },
      {
        id: "fileManager",
        title: "File Manager",
        type: "item",
        icon: <Icon.Save size={13} />,
        navLink: "/file-manager",
        collapsed: true,
      },
      {
        id: "calendar",
        title: "Calendar",
        type: "item",
        icon: <Icon.Calendar size={13} />,
        navLink: "/calendar",
      },
    ],
  },
  {
    id: "report",
    title: "Report",
    type: "collapse",
    icon: <Icon.Tablet size={13} />,
    children: [
      {
        id: "financial report",
        title: "nav.financial_report",
        type: "collapse",
        icon: <Icon.Tablet size={13} />,
        children: [
          {
            id: "money_report",
            title: "Money Report",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/money-report",
          },
          {
            id: "task_report",
            title: "Task Report",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/task-report",
          },
          {
            id: "employee_report",
            title: "Employee Report",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/employee-report",
          },
          {
            id: "manual_report",
            title: "Manual Report",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/manual-report",
          },
        ],
      },
      {
        id: "student_report",
        title: "Student Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/university/student-report",
      },
      {
        id: "template",
        title: "Template",
        type: "item",
        icon: <Icon.FileText size={20} />,
        navLink: "/app/template",
      },
    ],
  },
  {
    id: "documentation",
    title: "Information about the system",
    icon: <Icon.Info size={20} />,
    type: "item",
    navLink: "/sysinfo",
  },
];

let subManagerNavigation = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "collapse",
    icon: <Icon.Home size={20} />,
    children: [
      {
        id: "home",
        title: "Homes",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/home",
      },
      {
        id: "user_view",
        title: "View My Profile",
        type: "item",
        icon: <Icon.Users size={14} />,
        navLink: "/app/user/user-view",
      },
    ],
  },
  {
    id: "academic_system",
    title: "nav.academic_system",
    type: "collapse",
    icon: <Icon.Award size={20} />,
    children: [
      {
        id: "academic_affairs",
        title: "nav.academic_affairs",
        type: "collapse",
        icon: <Icon.Circle size={13} />,
        children: [
          {
            id: "studyYear",
            title: "Study Year",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/study-year",
          },
          {
            id: "subjects",
            title: "Subjects",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/subject",
          },
          {
            id: "jadwal",
            title: "Jadwal",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/jadwal",
          },
          {
            id: "online_exams",
            title: "الإختبارات الإكترونية",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/lecturer/online-exams",
          },
        ],
      },
      {
        id: "registration_admission",
        title: "nav.registration_admission",
        type: "collapse",
        icon: <Icon.Circle size={13} />,
        children: [
          {
            id: "student",
            title: "Students",
            type: "item",
            icon: <Icon.Circle size={13} />,
            navLink: "/panel/university/student",
          },
          // {
          //   id: "student_housing",
          //   title: "nav.student_housing",
          //   type: "item",
          //   icon: <Icon.Circle size={13} />,
          //   navLink: "/panel/university/student-housing",
          // },
        ],
      },
    ],
  },
  {
    id: "task",
    title: "Task",
    type: "collapse",
    icon: <Icon.Grid size={20} />,
    children: [
      {
        id: "listTask",
        title: "Task List",
        type: "item",
        icon: <Icon.Archive size={14} />,
        navLink: "/app/task/list",
      },
      {
        id: "todo",
        title: "Todo",
        type: "item",
        icon: <Icon.Zap size={20} />,
        navLink: "/todo/:filter",
        filterBase: "/todo/all",
      },
    ],
  },
  {
    id: "finance",
    title: "Finance",
    type: "collapse",
    icon: <Icon.BookOpen size={16} />,
    children: [
      {
        id: "money_request",
        title: "Money Request",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/money-request",
      },
      {
        id: "finance_report",
        title: "Finance Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/finance-report",
      },
    ],
  },
  {
    id: "report",
    title: "Report",
    type: "collapse",
    icon: <Icon.Tablet size={16} />,
    children: [
      {
        id: "task_report",
        title: "Task Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/task-report",
      },
      {
        id: "manual_report",
        title: "Manual Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/manual-report",
      },
    ],
  },
  {
    id: "template",
    title: "Template",
    type: "item",
    icon: <Icon.FileText size={20} />,
    navLink: "/app/template",
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <Icon.Mail size={20} />,
    navLink: "/email/:filter",
    filterBase: "/email/inbox",
  },
  {
    id: "chat",
    title: "Chat",
    type: "item",
    icon: <Icon.MessageSquare size={20} />,
    navLink: "/chat",
  },
  {
    id: "fileManager",
    title: "File Manager",
    type: "item",
    icon: <Icon.Save size={20} />,
    navLink: "/file-manager",
    collapsed: true,
  },
  {
    id: "calendar",
    title: "Calendar",
    type: "item",
    icon: <Icon.Calendar size={20} />,
    navLink: "/calendar",
  },
  {
    id: "documentation",
    title: "Information about the system",
    icon: <Icon.Info size={20} />,
    type: "item",
    navLink: "/sysinfo",
  },
];

let accountantNavigation = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "collapse",
    icon: <Icon.Home size={20} />,
    children: [
      {
        id: "home",
        title: "Homes",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/home",
      },
      {
        id: "bookkeeping",
        title: "Bookkeeping",
        type: "item",
        icon: <Icon.Inbox size={15} />,
        navLink: "/bookkeeping",
      },
      {
        id: "user_view",
        title: "View My Profile",
        type: "item",
        icon: <Icon.Users size={14} />,
        navLink: "/app/user/user-view",
      },
    ],
  },
  {
    type: "groupHeader",
    groupTitle: "PAGES",
  },

  {
    id: "task",
    title: "Task",
    type: "collapse",
    icon: <Icon.Grid size={20} />,
    children: [
      {
        id: "listTask",
        title: "Task List",
        type: "item",
        icon: <Icon.Archive size={14} />,
        navLink: "/app/task/list",
      },
      {
        id: "todo",
        title: "Todo",
        type: "item",
        icon: <Icon.Zap size={20} />,
        navLink: "/todo/:filter",
        filterBase: "/todo/all",
      },
    ],
  },
  {
    id: "finance",
    title: "Finance",
    type: "collapse",
    icon: <Icon.BookOpen size={16} />,
    children: [
      {
        id: "money_request",
        title: "Money Request",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/money-request",
      },
      {
        id: "finance_report",
        title: "Finance Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/finance-report",
      },
      {
        id: "money_report",
        title: "Money Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/money-report",
      },
    ],
  },
  {
    id: "report",
    title: "Report",
    type: "collapse",
    icon: <Icon.Tablet size={16} />,
    children: [
      {
        id: "task_report",
        title: "Task Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/task-report",
      },
      {
        id: "manual_report",
        title: "Manual Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/manual-report",
      },
    ],
  },
  {
    id: "template",
    title: "Template",
    type: "item",
    icon: <Icon.FileText size={20} />,
    navLink: "/app/template",
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <Icon.Mail size={20} />,
    navLink: "/email/:filter",
    filterBase: "/email/inbox",
  },
  {
    id: "chat",
    title: "Chat",
    type: "item",
    icon: <Icon.MessageSquare size={20} />,
    navLink: "/chat",
  },
  {
    id: "fileManager",
    title: "File Manager",
    type: "item",
    icon: <Icon.Save size={20} />,
    navLink: "/file-manager",
    collapsed: true,
  },
  {
    id: "calendar",
    title: "Calendar",
    type: "item",
    icon: <Icon.Calendar size={20} />,
    navLink: "/calendar",
  },
  {
    type: "groupHeader",
    groupTitle: "SUPPORT",
  },
  {
    id: "documentation",
    title: "Information about the system",
    icon: <Icon.Info size={20} />,
    type: "item",
    navLink: "/sysinfo",
  },
];

let employeeNavigation = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    icon: <Icon.Home size={20} />,
    navLink: "/home",
  },
  {
    id: "user_view",
    title: "View My Profile",
    type: "item",
    icon: <Icon.Users size={20} />,
    navLink: "/app/user/user-view",
  },
  {
    id: "administrative_system",
    title: "nav.administrative_system",
    type: "collapse",
    icon: <Icon.Circle size={13} />,
    children: [
      {
        id: "general admin",
        title: "nav.general_admin",
        type: "collapse",
        icon: <Icon.Circle size={13} />,
        children: [
          {
            id: "listTask",
            title: "Task List",
            type: "item",
            icon: <Icon.List size={15} />,
            navLink: "/app/task/list",
          },
          {
            id: "todo",
            title: "Todo",
            type: "item",
            icon: <Icon.Zap size={20} />,
            navLink: "/todo/:filter",
            filterBase: "/todo/all",
          },
          {
            id: "template",
            title: "Template",
            type: "item",
            icon: <Icon.FileText size={20} />,
            navLink: "/app/template",
          },
        ],
      },
    ],
  },
  {
    id: "feature 3",
    title: "feature_3",
    type: "collapse",
    icon: <Icon.Circle size={13} />,
    children: [
      {
        id: "email",
        title: "Email",
        type: "item",
        icon: <Icon.Mail size={13} />,
        navLink: "/email/:filter",
        filterBase: "/email/inbox",
      },
      {
        id: "chat",
        title: "Chat",
        type: "item",
        icon: <Icon.MessageSquare size={13} />,
        navLink: "/chat",
      },
      {
        id: "fileManager",
        title: "File Manager",
        type: "item",
        icon: <Icon.Save size={13} />,
        navLink: "/file-manager",
        collapsed: true,
      },
      {
        id: "calendar",
        title: "Calendar",
        type: "item",
        icon: <Icon.Calendar size={13} />,
        navLink: "/calendar",
      },
    ],
  },
  {
    id: "finance",
    title: "Finance",
    type: "collapse",
    icon: <Icon.BookOpen size={16} />,
    children: [
      {
        id: "money_request",
        title: "Money Request",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/money-request",
      },
    ],
  },
  {
    id: "report",
    title: "Report",
    type: "collapse",
    icon: <Icon.Tablet size={13} />,
    children: [
      {
        id: "manual_report",
        title: "Manual Report",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/manual-report",
      },
    ],
  },
  {
    id: "documentation",
    title: "Information about the system",
    icon: <Icon.Info size={20} />,
    type: "item",
    navLink: "/sysinfo",
  },
];

let lecturerNavigation = [
  {
    id: "home",
    title: "Homes",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/home",
  },
  {
    id: "jadwal",
    title: "Jadwal",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/panel/university/jadwal",
  },
  {
    id: "subject",
    title: "Subjects",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/panel/university/subject",
  },
  {
    id: "student_report",
    title: "Student Report",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/panel/university/student-report",
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/email/:filter",
    filterBase: "/email/inbox",
  },
  {
    id: "calendar",
    title: "Calendar",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/calendar",
  },
  {
    id: "online_exams",
    title: "الإختبارات الإكترونية",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/panel/lecturer/online-exams",
  },
];

let staffNavigation = [
  {
    id: "home",
    title: "Student_records",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/home",
  },
  // {
  //   id: "academic_system",
  //   title: "nav.academic_system",
  //   type: "collapse",
  //   icon: <Icon.Award size={20} />,
  //   children: [
  //     {
  //       id: "registration_admission",
  //       title: "nav.registration_admission",
  //       type: "collapse",
  //       icon: <Icon.Circle size={13} />,
  //       children: [
  //         {
  //           id: "student_housing",
  //           title: "nav.student_housing",
  //           type: "item",
  //           icon: <Icon.Circle size={13} />,
  //           navLink: "/panel/university/student-housing",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: "user_view",
  //   title: "View My Profile",
  //   type: "item",
  //   icon: <Icon.Circle size={13} />,
  //   navLink: "/app/user/user-view",
  // },
  // {
  //   id: "studyYear",
  //   title: "Study Year",
  //   type: "item",
  //   icon: <Icon.Circle size={13} />,
  //   navLink: "/panel/university/study-year",
  // },
  // {
  //   id: "subject",
  //   title: "Subjects",
  //   type: "item",
  //   icon: <Icon.Circle size={13} />,
  //   navLink: "/panel/university/subject",
  // },
  // {
  //   id: "websetting",
  //   title: "Website Setting",
  //   type: "collapse",
  //   icon: <Icon.Settings size={13} />,
  //   children: [
  //     {
  //       id: "frontinfo",
  //       title: "Frontinfo",
  //       type: "item",
  //       icon: <Icon.Circle size={13} />,
  //       navLink: "/panel/websetting/frontinfo",
  //     },
  //     {
  //       id: "slider",
  //       title: "Slider Images",
  //       type: "item",
  //       icon: <Icon.Circle size={13} />,
  //       navLink: "/panel/websetting/slider",
  //     },
  //     {
  //       id: "gallery",
  //       title: "Image Gallery",
  //       type: "item",
  //       icon: <Icon.Circle size={13} />,
  //       navLink: "/panel/websetting/gallery",
  //     },
  //     {
  //       id: "blog",
  //       title: "Blog",
  //       type: "item",
  //       icon: <Icon.Circle size={13} />,
  //       navLink: "/panel/websetting/blog",
  //     },
  //     {
  //       id: "news",
  //       title: "News",
  //       type: "item",
  //       icon: <Icon.Circle size={13} />,
  //       navLink: "/panel/websetting/news",
  //     },
  //   ],
  // },
  // {
  //   id: "onlineStudies",
  //   title: "Online Studies",
  //   icon: <Icon.Calendar size={13} />,
  //   type: "collapse",
  //   children: [
  //     {
  //       id: "online_department",
  //       title: "nav.O_Department",
  //       type: "item",
  //       icon: <Icon.Circle size={13} />,
  //       navLink: "/panel/app/online/department/list",
  //     },
  //     {
  //       id: "online_subject",
  //       title: "Online_Subject",
  //       type: "item",
  //       icon: <Icon.Circle size={13} />,
  //       navLink: "/panel/app/online/subject/list",
  //     },
  //     {
  //       id: "online_student",
  //       title: "Online_Students",
  //       type: "item",
  //       icon: <Icon.Circle size={13} />,
  //       navLink: "/panel/app/online/student/list",
  //     },
  //     {
  //       id: "online_exam",
  //       title: "Online_Exams",
  //       type: "item",
  //       icon: <Icon.Circle size={13} />,
  //       navLink: "/panel/app/online/exam/list",
  //     },
  // {
  //   id: "questionnaire_entry_list",
  //   title: "Questionnaire Entry",
  //   type: "item",
  //   icon: <Icon.Circle size={13} />,
  //   navLink: "/panel/websetting/questionnaire/entry",
  // },
  // {
  //   id: "questionnaire",
  //   title: "Manage Questionnaire",
  //   type: "item",
  //   icon: <Icon.Circle size={13} />,
  //   navLink: "/panel/websetting/admission/questionnaire",
  // },
  //   ],
  // },
];

let operatorNavigation = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "collapse",
    icon: <Icon.Home size={20} />,
    children: [
      {
        id: "home",
        title: "Homes",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/home",
      },
      {
        id: "user_view",
        title: "View My Profile",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/app/user/user-view",
      },
    ],
  },
  {
    id: "university",
    title: "University",
    type: "collapse",
    icon: <Icon.Award size={20} />,
    children: [
      {
        id: "student",
        title: "Students",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/university/student",
      },
      {
        id: "subject",
        title: "Subjects",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/university/subject",
      },
    ],
  },
  {
    id: "Admission",
    title: "Admission",
    type: "collapse",
    icon: <Icon.Archive size={14} />,
    children: [
      {
        id: "info",
        title: "Info",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/admission",
      },
      {
        id: "applicant_list",
        title: "Applicant List",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/admission/entry",
      },
      {
        id: "questionnaire_entry_list",
        title: "Questionnaire Entry",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/questionnaire/entry",
      },
      {
        id: "questionnaire",
        title: "Manage Questionnaire",
        type: "item",
        icon: <Icon.Circle size={13} />,
        navLink: "/panel/websetting/admission/questionnaire",
      },
    ],
  },
];

let studentNavigation = [
  {
    id: "home",
    title: "Homes",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/home",
  },
  {
    id: "jadwal",
    title: "Jadwal",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/panel/university/jadwal",
  },
  {
    id: "student_report",
    title: "Student Report",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/panel/university/student-report",
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/email/:filter",
    filterBase: "/email/inbox",
  },
  {
    id: "calendar",
    title: "Calendar",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/calendar",
  },
  {
    id: "online_exams",
    title: "الإختبارات الإكترونية",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/panel/lecturer/online-exams",
  },
  // {
  //   id: "studyYear",
  //   title: "Study Year",
  //   type: "item",
  //   icon: <Icon.Circle size={13} />,
  //   navLink: "/panel/university/study-year",
  // },
];

let emptyNavigation = [];

let examMonitorNavigation = [
  {
    id: "online_exams",
    title: "الإختبارات الإكترونية",
    type: "item",
    icon: <Icon.Circle size={13} />,
    navLink: "/panel/lecturer/online-exams",
  },
];

export default () => {
  let user = getUser();
  switch (user.role) {
    case "admin":
      return adminNavigation;
    case "manager":
      return managerNavigation;
    case "sub_manager":
      return subManagerNavigation;
    case "accountant":
      return accountantNavigation;
    case "lecturer":
      return lecturerNavigation;
    case "staff":
      return staffNavigation;
    case "employee":
      return employeeNavigation;
    case "operator":
      return operatorNavigation;
    case "student":
      return studentNavigation;
    case "exam_monitor_boys":
    case "exam_monitor_girls":
      return examMonitorNavigation;
    default:
      return emptyNavigation;
  }
};
